import { render, staticRenderFns } from "./ProductTracking.vue?vue&type=template&id=51b6360c&"
import script from "./ProductTracking.vue?vue&type=script&lang=js&"
export * from "./ProductTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports